<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Have other research needs?</h2>
    <p>We offer a suite of solutions to help our clients identify, verify and engage with African corporates.</p>
    <p>Through an extensive team of in-country analysts, technology and strategic partnerships, we serve a growing number of multinationals, financial institutions, advisories and public agencies.</p>
    <div class="action-wrap">
      <a @click="openSolutions" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">See Solutions</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'market-map-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openSolutions() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Solutions Conversion Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Solutions Conversion Block',
      })
      this.$router.push({ name: 'solutions-page' })
    },
  },
}
</script>
